import React from 'react';
import DashboardHeaderMain from './DashboardHeader';
import DashboardHeaderPart2 from '../CompanyDashboardPart2/DashboardHeader';

/**
 * Renders the correct dashboard header based on company.dashboardType (assigned by admin).
 * This prevents "mixed" nav links when admin changes a company's dashboard from one type to another.
 * - company.dashboardType === 'part2' → Part2 header (Part2 nav links only)
 * - otherwise → Main header (main dashboard nav links only)
 */
function DashboardHeaderRouter({ company, companyLanguage, onLogout, bills, sales, recoveries, persons }) {
  const isPart2 = company?.dashboardType === 'part2' ||
    company?.dashboardType === 'dashboard-part2' ||
    company?.dashboardType === 'part-2' ||
    company?.dashboardType === 'ur' ||
    company?.dashboardType === 'urdu';

  if (isPart2) {
    return (
      <DashboardHeaderPart2
        company={company}
        companyLanguage={companyLanguage}
        onLogout={onLogout}
        bills={bills}
        sales={sales}
        recoveries={recoveries}
        persons={persons}
      />
    );
  }

  return (
    <DashboardHeaderMain
      company={company}
      companyLanguage={companyLanguage}
      onLogout={onLogout}
      bills={bills}
      sales={sales}
      recoveries={recoveries}
      persons={persons}
    />
  );
}

export default DashboardHeaderRouter;
